import { AdminShell } from "@/components/admin/admin-shell";
import { SupportInbox } from "@/components/support/support-inbox";

export function AdminSupportPage() {
  return (
    <AdminShell>
      <main className="flex min-h-0 flex-1 p-4 sm:p-5">
        <SupportInbox isAdmin={true} />
      </main>
    </AdminShell>
  );
}
